export const INJECTED_THEME_PROPERTYNAME = '_blocksTheme' as const;
